import React, { useState } from "react";
import {
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  MDBIcon,
} from "mdb-react-ui-kit";
import axios, { toFormData } from "axios";
import DataTable from "../DataTable";
import { toast } from "react-toastify";
import { getCurrentDate } from "../../utilities/getCurrentDate";
import voucherDateAndTimeFormatter from "../../utilities/voucherDateAndTimeFormatter";
import convertToUnderscoreFormat from "../../utilities/convertToUnderscoreFormat";
import Loader from "../Loader";
import API_BASE_URL from "../../utilities/apiConfig";
import axiosInstance from "../../utilities/apiConfig";

const MisReporting = () => {
  const [loading, setLoading] = useState(false);
  const [voucherDetailsList, setVoucherDetailsList] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [parameters, setParameters] = useState({
    purchaserId: "",
    fromDate: "",
    toDate: "",
  });

  const voucherTableColumns = [
    {
      field: "id",
      headerName: "ID",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherType",
      headerName: "Voucher Type",
      type: "text",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherBookNo",
      headerName: "Book No",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherSrNo",
      headerName: "Sr No",
      type: "number",
      minWidth: 90,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherAmount",
      headerName: "Amount",
      type: "number",
      minWidth: 90,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "name",
      headerName: "Purchaser Name",
      minWidth: 130,
      flex: 1.5,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "purchaserType",
      headerName: "Purchaser Type",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "uttrakhandBarId",
      headerName: "Purchaser ID",
      minWidth: 130,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "voucherPurchaseDate",
      headerName: "Purchase Date",
      minWidth: 160,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
  ];

  const handleGetSoldVoucherDetailsByPurchaserId = async () => {
    try {
      setLoading(true);
      setShowTable(false);
      const formatted_bar_id = convertToUnderscoreFormat(
        parameters.purchaserId
      );
      const response = await axiosInstance.get(
        `/Dashboard/get_voucher_details_by_puchaser_id/${formatted_bar_id}/${parameters.fromDate}/${parameters.toDate}`
      );

      console.log(
        "this is handle get voucher details by user id",
        response.data
      );
      if (response.data.response.statusCode === 200) {
        console.log(response.data.voucherDetailsList);
        setVoucherDetailsList(response.data?.voucherDetailsList);
        setShowTable(true);
        toast.success(response.data.response.status);
      } else {
        toast.error(response.data.response.status);
      }
    } catch (error) {
      toast.error("Failed to get the data please try again");
      console.log(" this is error mesage form voucher details", error);
    } finally {
      setLoading(false);
    }
  };

  const formattedVoucherData = voucherDateAndTimeFormatter(voucherDetailsList, [
    "voucherPurchaseDate",
  ]);
  return (
    <>
      {loading && <Loader />}
      <div className="row justify-content-center mb-5">
        <div className="col-xxl-8">
          <div className="d-flex justify-content-between mb-3">
            <div className="col-md-8 d-flex flex-column align-items-start">
              <h3 className="text-center">MIS Report</h3>
              <MDBCardText className="text-small">
                Advocate or Venoder Details Between Provided Time Range.
              </MDBCardText>
            </div>
          </div>

          <div
            className="d-flex align-items-center"
            style={{ fontWeight: "semi-bold" }}
          >
            <div className="mb-4 mx-3 flex-fill d-flex flex-column align-items-start">
              <label htmlFor="barId" className="form-label">
                Enter Bar Id
              </label>
              <input
                type="text"
                id="purchaserId"
                name="purchaserId"
                value={setParameters.purchaserId}
                onChange={(e) => {
                  setParameters({ ...parameters, purchaserId: e.target.value });
                }}
                className="form-control"
                style={{ height: "40px" }}
              />
            </div>
            <div className="mb-4 mx-3 flex-fill d-flex flex-column align-items-start">
              <label htmlFor="fromDate" className="form-label">
                From Date
              </label>
              <input
                type="date"
                id="fromDate"
                name="fromDate"
                value={setParameters.fromDate}
                onChange={(e) => {
                  setParameters({ ...parameters, fromDate: e.target.value });
                }}
                className="form-control"
                style={{ height: "40px" }}
              />
            </div>
            <div className="mb-4 mx-3 flex-fill d-flex flex-column align-items-start">
              <label htmlFor="toDate" className="form-label">
                To Date
              </label>
              <input
                type="date"
                id="toDate"
                name="toDate"
                value={setParameters.toDate}
                onChange={(e) => {
                  setParameters({ ...parameters, toDate: e.target.value });
                }}
                className="form-control"
                style={{ height: "40px" }}
              />
            </div>
            <div className="mx-3">
              <MDBBtn
                color="primary"
                style={{ height: "40px", minWidth: "120px" }}
                onClick={() => {
                  handleGetSoldVoucherDetailsByPurchaserId();
                }}
              >
                View Details
              </MDBBtn>
            </div>
          </div>
        </div>
      </div>

      {showTable && (
        <DataTable
          tableName="Reporting Table"
          TableColumns={voucherTableColumns}
          TableData={formattedVoucherData}
        />
      )}
    </>
  );
};

export default MisReporting;
